import { defineStore } from "pinia";
import Services from '@/services/sutting/issuersNewIdentificationCardsServices'
import { mapList, mapIssuerNewIdentificationCard } from '@/helpers/mapFuncs'

export const useIssuersNewIdentificationCardsStore = defineStore("issuersNewIdentificationCards", {
persist: true,
state:()=>({
    issuerNewIdentificationCard: {},
    issuersNewIdentificationCards: [],
}),
getters : {
    getIssuerNewIdentificationCard() {
        return mapIssuerNewIdentificationCard(this.issuerNewIdentificationCard)
    },
    getIssuersNewIdentificationCards() {
        return this.issuersNewIdentificationCards.map(mapIssuerNewIdentificationCard)
    },
    getIssuersNewIdentificationCardsList() {
        return this.issuersNewIdentificationCards.map(mapList)
    }
},
actions : {
    /** Start Sets */
    setIssuerNewIdentificationCard(issuerNewIdentificationCard) {
        this.issuerNewIdentificationCard = issuerNewIdentificationCard
    },
    setIssuersNewIdentificationCards(issuersNewIdentificationCards) {
        this.issuersNewIdentificationCards = issuersNewIdentificationCards
    },
    /** End Sets */

    /** Start Actions */
    get(id) {
        return Services.get(id)
        .then((response)=>{
            this.setIssuerNewIdentificationCard(response.data.data)
            return response
        })
    },
    getAll(data) {
        return Services.getAll(data)
        .then((response)=>{
            this.setIssuersNewIdentificationCards(response.data.data??[])
            return response
        })
    },
    add(data){
        return Services.add(data)
        .then((response)=>{
            this.issuersNewIdentificationCards.push(response.data.data)
            return response
        })
    },
    edit(id, data){
        return Services.edit(id, data)
        .then((response)=>{
            this.issuersNewIdentificationCards[this.issuersNewIdentificationCards.findIndex((x)=>x.id == id)] = response.data.data
            return response
        })
    },
    delete(id){
        return Services.delete(id)
        .then((response)=>{
            this.issuersNewIdentificationCards = this.issuersNewIdentificationCards.filter((x)=>x.id != id)
            return response
        })
    },
    /** End Actions */
}
});
